import React, { useState } from 'react';
import { Send, FileText, Loader2 } from 'lucide-react';

interface Props {
  patientName: string;
  patientAge: number;
}

export default function ReferralGenerator({ patientName, patientAge }: Props) {
  const [receivingDoctor, setReceivingDoctor] = useState('');
  const [specialty, setSpecialty] = useState('');
  const [diagnosis, setDiagnosis] = useState('');
  const [referralReason, setReferralReason] = useState('');
  const [letter, setLetter] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    if (!receivingDoctor || !specialty || !diagnosis || !referralReason) {
      alert("يرجى ملء جميع الحقول المطلوبة.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('/api/clinical/generate-referral', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ patientName, patientAge, diagnosis, referralReason, receivingDoctor, specialty }),
      });
      
      const data = await response.json();
      if (response.ok) {
        setLetter(data.letter);
      } else {
        alert(data.error || 'فشل توليد الخطاب.');
      }
    } catch (err) {
      alert('خطأ في الاتصال بالسيرفر.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg border border-slate-200">
      <h3 className="text-lg font-bold text-slate-800 mb-4">توليد خطاب إحالة (Referral Letter)</h3>
      
      <div className="grid grid-cols-2 gap-3 mb-3">
        <input placeholder="اسم الطبيب المستقبل" value={receivingDoctor} onChange={e => setReceivingDoctor(e.target.value)} className="text-xs p-2 rounded border" />
        <input placeholder="التخصص" value={specialty} onChange={e => setSpecialty(e.target.value)} className="text-xs p-2 rounded border" />
      </div>
      
      <textarea placeholder="التشخيص" value={diagnosis} onChange={e => setDiagnosis(e.target.value)} className="w-full text-xs p-2 rounded border mb-3" rows={2} />
      <textarea placeholder="سبب الإحالة" value={referralReason} onChange={e => setReferralReason(e.target.value)} className="w-full text-xs p-2 rounded border mb-3" rows={3} />
      
      <button 
        onClick={handleGenerate}
        disabled={loading}
        className="w-full flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white py-2 rounded text-xs font-bold disabled:opacity-50"
      >
        {loading ? <Loader2 className="animate-spin w-4 h-4" /> : <FileText className="w-4 h-4" />}
        {loading ? 'جاري التوليد...' : 'توليد خطاب الإحالة'}
      </button>

      {letter && (
        <div className="mt-4 bg-slate-50 p-3 rounded border text-right text-xs leading-relaxed whitespace-pre-wrap">
          {letter}
        </div>
      )}
    </div>
  );
}
